// デモページ作成の入力ルール（サーバー側 libraries/utils/demo_page.py の DemoPage と同期させること）
export const DEMO_PAGE_NAME_MAX_LENGTH = 64;
export const DEMO_TITLE_MAX_LENGTH = 100;
export const DEMO_RELOAD_SEC_MIN = 1;
export const DEMO_RELOAD_SEC_MAX = 86400;
export const DEMO_RELOAD_SEC_DEFAULT = 3600;

const PAGE_NAME_CHARS = /^[A-Za-z0-9_-]+$/;

/** ページ名の入力エラー（未入力はエラーにしない） */
export const pageNameError = (name) => {
    if (!name) return null;
    if (!PAGE_NAME_CHARS.test(name)) return "使用できない文字が含まれています";
    if (name.length > DEMO_PAGE_NAME_MAX_LENGTH) return `${DEMO_PAGE_NAME_MAX_LENGTH}文字以内で入力してください`;
    return null;
};

export const isValidReloadSec = (value) => {
    if (value === null || value === undefined || String(value).trim() === "") return false;
    const sec = Number(value);
    return Number.isInteger(sec) && sec >= DEMO_RELOAD_SEC_MIN && sec <= DEMO_RELOAD_SEC_MAX;
};

export const reloadHint = (isAutoReload, value) => {
    if (!isAutoReload) return "自動リロードしません";
    if (!isValidReloadSec(value)) return `${DEMO_RELOAD_SEC_MIN}〜${DEMO_RELOAD_SEC_MAX} の整数で指定してください`;
    const sec = Number(value);
    return `≒ ${Math.round((sec / 60) * 10) / 10} 分（${Math.round((sec / 3600) * 100) / 100} 時間）`;
};

/** 送信する秒数（自動リロードしないときは 0） */
export const reloadSecToSend = (isAutoReload, value) => (isAutoReload ? Number(value) : 0);

/** 自動リロードの入力が保存できる状態か（リロードしないときは秒数を問わない） */
export const canSaveDemo = (isAutoReload, value) => !isAutoReload || isValidReloadSec(value);

export const canCreateDemo = (name, isAutoReload, value) => (
    !!name && pageNameError(name) === null && canSaveDemo(isAutoReload, value)
);

/** 保存済みの秒数をフォームの状態に戻す（リロードしない場合は ON にしたとき用に既定秒数を入れておく） */
export const reloadFormState = (sec) => (
    sec > 0 ? { isAutoReload: true, reloadSec: String(sec) } : { isAutoReload: false, reloadSec: String(DEMO_RELOAD_SEC_DEFAULT) }
);

/** 一覧に出す自動リロードの表記（割り切れる最大の単位で出す） */
export const reloadLabel = (sec) => {
    if (!sec) return "なし";
    if (sec % 3600 === 0) return `${sec / 3600} 時間`;
    if (sec % 60 === 0) return `${sec / 60} 分`;
    return `${sec} 秒`;
};

const ISO_DATETIME = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/;

/** サーバーの作成日時（YYYY-MM-DDTHH:MM:SS）を一覧の表記にする */
export const formatDemoDate = (value) => {
    const m = ISO_DATETIME.exec(value ?? "");
    return m ? `${m[1]}/${m[2]}/${m[3]} ${m[4]}:${m[5]}:${m[6]}` : "-";
};
